import { cn } from '@/shadcn/lib/utils';

interface RoadmapSideContentProps {
    index: number;
    side: 'left' | 'right';
    title: string;
    body: string;
    icon: string;
}

export function RoadmapSideContent(props: RoadmapSideContentProps) {
    const isRight = props.side === 'right';

    function getTranslateYClass(index: number) {
        switch (index) {
            case 0:
                return 'translate-y-[1%] sm:translate-y-[2%] md:translate-y-[8%] xl:translate-y-[12%]';
            case 1:
                return 'translate-y-[0%] sm:translate-y-[-5%]  md:translate-y-[3%] xl:translate-y-[7%]';
            case 2:
                return 'translate-y-[1%] sm:translate-y-[-4%] md:translate-y-[3%]';
            case 3:
                return 'translate-y-[15%] sm:translate-y-[18%] md:translate-y-[30%] xl:translate-y-[35%]';
            default:
                return '';
        }
    }

    const textContent = (
        <div
            className={cn(
                'transform-gpu',
                getTranslateYClass(props.index),
                isRight
                    ? 'pl-[25px] md:pl-[50px] xl:pl-[120px]'
                    : 'text-right pr-[25px] md:pr-[50px] xl:pr-[120px]',
            )}
        >
            <h4 className="font-display font-bold text-[#191919] whitespace-pre-line mb-[20px] tracking-[-0.05em] text-[17px] leading-[1.2] md:text-[20px] xl:text-[22px]">
                {props.title}
            </h4>

            <p
                className={cn(
                    'text-[#191919]/60 mt-3 leading-[1.5] max-w-[260px] text-[11px] md:text-[13px] xl:text-[14px]',
                    !isRight && 'ml-auto',
                )}
            >
                {props.body}
            </p>
        </div>
    );

    const iconContent = (
        <div
            className={cn(
                isRight ? 'flex justify-end pr-[40px] md:pr-[70px]' : 'pl-[40px] md:pl-[70px]',
            )}
        >
            <img src={props.icon} alt="" className="w-[100px] md:w-[130px] xl:w-[150px]" />
        </div>
    );

    return (
        <>
            {isRight ? (
                <>
                    {iconContent}
                    {textContent}
                </>
            ) : (
                <>
                    {textContent}
                    {iconContent}
                </>
            )}
        </>
    );
}
